import { RECEIVE_COST_LIMITS } from "../actions/costLimits";

const initialState = {};

const costLimits = (state = initialState, action) => {
  switch (action.type) {
    case RECEIVE_COST_LIMITS:
      const costLimits = {};
      action.costLimits.forEach(costLimit => {
        costLimits[costLimit.id] = costLimit;
      });
      return Object.assign({}, state, costLimits);
    default:
      return state;
  }
};

export default costLimits;



// WEBPACK FOOTER //
// ./src/reducers/costLimits.js